// PlayerPortal.jsx
import { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PlayerContext } from '../resource/contexts.js';

let createPortal = () => null;

export const PlayerPortal = ({ children }) => {
  const { player } = useContext(PlayerContext);
  const [createPortalLoaded, setCreatePortalLoaded] = useState(false);

  useEffect(() => {
    const loadCreatePortal = async () => {
      const { createPortal: loadedCreatePortal } = await import(
        '../partial/react-dom/createPortal.js'
      );
      if (loadedCreatePortal) {
        createPortal = loadedCreatePortal;
        setCreatePortalLoaded(true);
      }
    };
    loadCreatePortal();
  }, []);

  if (player && createPortalLoaded) {
    const playerElement = player.el();

    if (playerElement) {
      return createPortal(children, playerElement);
    }
  }

  return null;
};

PlayerPortal.propTypes = {
  children: PropTypes.node,
};

PlayerPortal.defaultProps = {};

export default PlayerPortal;
